import { PIMSTER_ORIGIN_REGEX } from '../../../constants';

export const isInternalMessageOrigin = (value: unknown): boolean =>
  typeof value === 'string' && PIMSTER_ORIGIN_REGEX.test(value);
